import { createSlice } from "@reduxjs/toolkit";
import { StopPoint } from "../../types/StopPoint";

export interface StopPointStateProps {
  selectedStopPoint?: StopPoint;
}

const initialState: StopPointStateProps = {};

export const StopPointSlice = createSlice({
  name: "stopPoint",
  initialState,
  reducers: {
    setSelectedStopPoint: (state, action) => {
      state.selectedStopPoint = action.payload;
    },
  },
});

export const StopPointActions = StopPointSlice.actions;

export default StopPointSlice.reducer;
